import { useContext, useMemo } from 'react';
import { SearchContext } from '../../SearchProvider';
import { SearchLocationsInCountry } from '../../SearchProvider/types';
import { Typo3Context } from '../index';
import { selectVehicleCentersMap } from '../selectors';
import { Typo3State } from '../types';

export const getFilteredLocationCodes = (
  filterByCodeCountry: string,
  typo3: Typo3State,
  locationsGroupedByCountries: SearchLocationsInCountry[]
): string[] => {
  // a Map of `searchValue` => `VehicleCenter`
  const map = selectVehicleCentersMap(typo3);
  // `undefined` or `SearchLocationsInCountry`
  const selectedCountry = locationsGroupedByCountries.find(
    search => search.countryId === filterByCodeCountry
  );
  // list of `codeLocation`s/`searchValue`s
  const locationCodes = selectedCountry ? selectedCountry.locationCodes : [];
  // list of `undefined` or `VehicleCenter`
  const locations = locationCodes.map(c => map.get(c));
  // `undefined` or main `VehicleCenter` in selected country
  const main = locations.find(l => (l ? l.isMainLocationInCountry : false));
  // list of all other `VehicleCenter`s
  const rest = locations.filter(l => (l ? !l.isMainLocationInCountry : false));

  return [
    // we want main `VehicleCenter` to be the first entry
    main ? main.searchValue : '',
    // after that the rest should follow
    ...rest.map(vh => (vh ? vh.searchValue : ''))
    // filter to remove empty strings
  ].filter(Boolean);
};

export const useFilterByCodeCountry = (filterByCodeCountry: string) => {
  const typo3 = useContext(Typo3Context);
  const { locationsGroupedByCountries, sortedLocationCodes } = useContext(
    SearchContext
  );
  const codeLocations = useMemo(() => {
    if (!filterByCodeCountry) {
      return sortedLocationCodes;
    }
    return getFilteredLocationCodes(
      filterByCodeCountry,
      typo3,
      locationsGroupedByCountries
    );
  }, [
    filterByCodeCountry,
    typo3,
    locationsGroupedByCountries,
    sortedLocationCodes
  ]);
  return codeLocations;
};
